import { Helmet } from "react-helmet-async";
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from "@/components/ui/accordion";
import { Reveal } from "@/components/motion";
import { FAQS } from "@/data";

export default function Faq() {
  const schema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: FAQS.map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: { "@type": "Answer", text: f.a },
    })),
  };

  return (
    <section data-testid="faq" className="mx-auto max-w-[1400px] px-6 py-24 lg:px-10 lg:py-32">
      <Helmet>
        <script type="application/ld+json">{JSON.stringify(schema)}</script>
      </Helmet>
      <div className="grid gap-12 lg:grid-cols-12">
        <Reveal className="lg:col-span-4">
          <p className="overline text-[var(--brand)]">FAQ</p>
          <h2 className="mt-5 font-display text-4xl font-extrabold leading-[0.95] tracking-tighter sm:text-5xl">
            Questions, answered.
          </h2>
          <p className="mt-6 text-[var(--ink-soft)]">
            Everything you need to know before your first clean. Still curious? Give us a call.
          </p>
        </Reveal>

        <div className="lg:col-span-7 lg:col-start-6">
          <Accordion type="single" collapsible className="border-t border-[var(--line)]">
            {FAQS.map((f, i) => (
              <AccordionItem key={i} value={`faq-${i}`} data-testid={`faq-item-${i}`} className="border-[var(--line)]">
                <AccordionTrigger className="py-6 font-display text-lg font-bold tracking-tight text-[var(--ink)] hover:no-underline sm:text-xl">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="pb-6 text-base leading-relaxed text-[var(--ink-soft)]">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
